import React from 'react';
import { CalendarDays, Heart } from 'lucide-react';

// LEAVE-UI-001: premium page header (presentation only). Illustration is decorative.
export const LeaveHeader = () => (
  <div className="an-rise relative" data-testid="leave-page-header">
    <div className="flex items-center justify-between gap-6">
      <div className="flex flex-col sm:flex-row sm:items-center gap-4 sm:gap-4 min-w-0">
        <div className="h-14 w-14 sm:h-16 sm:w-16 shrink-0 rounded-2xl bg-gradient-to-br from-violet-50 to-indigo-50 border border-violet-100/80 text-violet-600 flex items-center justify-center shadow-[0_10px_30px_-16px_rgba(109,78,224,.45)]">
          <CalendarDays className="h-7 w-7" strokeWidth={1.75} />
        </div>
        <div className="min-w-0">
          <h1 className="text-[24px] sm:text-[28px] font-extrabold text-slate-900 tracking-tight leading-none break-words" data-testid="leave-page-title">Leave Management</h1>
          <p className="text-[13.5px] text-slate-500 mt-1.5">Manage your leaves, view balance, and plan ahead.</p>
        </div>
      </div>
      <div className="hidden md:flex items-center gap-4 shrink-0 pr-2" aria-hidden="true">
        <img src="/leave-illustration.png" alt="" className="h-[88px] w-auto select-none drop-shadow-[0_18px_28px_rgba(79,70,229,.18)]" draggable={false} data-testid="leave-illustration" />
        <div className="hidden xl:block text-right leading-tight">
          <span className="an-accent block text-[17px] leading-5">Take time</span>
          <span className="an-accent block text-[17px] leading-5">You do great things <Heart className="inline h-4 w-4 -mt-1 text-violet-500" strokeWidth={2} /></span>
        </div>
      </div>
    </div>
  </div>
);

export default LeaveHeader;
